export const noVisitorMessage = 'flagship Visitor not initialized.'
export const noVisitorDefault = 'fsVisitor not initialized, returns default value'

  export const GET_FLAG_CAST_ERROR ='Flag for key {0} has a different type. Default value is returned.'
  export const GET_METADATA_CAST_ERROR = 'Flag for key {0} has a different type with defaultValue, an empty metadata object is returned'
